import * as React from "react";
import * as ReactQuery from "react-query";
import * as uuid from "uuid";

import {
  BodyScrollControllerProvider,
  CustomerSessionProvider,
  JoinDrawerProvider,
  JoinFormProvider,
  LoginFormProvider,
  OneTimePasswordProvider,
  PresenterForScrollProvider,
  ProminentErrorProvider,
} from "../Common";

import {
  ContentRouteProvider,
  ReactJoinAnalyticsProvider,
  ReactJoinFeaturesProvider,
  ReactJoinInitialStateProvider,
  ReactJoinLoginAppProvider,
  TopMessagesProvider,
  useReactJoinAnalytics,
  useReactJoinInitialState,
} from "./providers";

import { Page } from "./Page";

interface AppProps {
  mountElement: Element;
}

const queryClient = new ReactQuery.QueryClient();

export const App: React.FunctionComponent<AppProps> = (props) => {
  const bodyScrollControllerGuid = React.useMemo(() => {
    return uuid.v4();
  }, []);

  return (
    <BodyScrollControllerProvider guid={bodyScrollControllerGuid}>
      <ReactQuery.QueryClientProvider client={queryClient}>
        <ProminentErrorProvider>
          <ReactJoinInitialStateProvider mountElement={props.mountElement}>
            <ReactJoinFeaturesProvider>
              <ReactJoinAnalyticsProvider>
                <CustomerSessionProvider
                  useInitialState={useReactJoinInitialState}
                >
                  <ReactJoinLoginAppProvider>
                    <TopMessagesProvider>
                      <ContentRouteProvider>
                        <PresenterForScrollProvider>
                          <LoginFormProvider
                            useInitialState={useReactJoinInitialState}
                          >
                            <JoinFormProvider
                              useInitialState={useReactJoinInitialState}
                            >
                              <OneTimePasswordProvider
                                useInitialState={useReactJoinInitialState}
                                useAnalytics={useReactJoinAnalytics}
                              >
                                <JoinDrawerProvider onlyUsedForOneTimePassword>
                                  <Page />
                                </JoinDrawerProvider>
                              </OneTimePasswordProvider>
                            </JoinFormProvider>
                          </LoginFormProvider>
                        </PresenterForScrollProvider>
                      </ContentRouteProvider>
                    </TopMessagesProvider>
                  </ReactJoinLoginAppProvider>
                </CustomerSessionProvider>
              </ReactJoinAnalyticsProvider>
            </ReactJoinFeaturesProvider>
          </ReactJoinInitialStateProvider>
        </ProminentErrorProvider>
      </ReactQuery.QueryClientProvider>
    </BodyScrollControllerProvider>
  );
};
